// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2Jobh","imageUploader":"EGiftCard_imageUploader__1i8k2"};